import React, { useState, useRef } from 'react';
import { useMutation } from '@apollo/react-hooks';

import Tabs from '../../../../../components/Tabs';
import Tab from '../../../../../components/Tab';
import BackLink from '../../../../../components/BackLink';


import PackSettings from '../components/pack-settings/PackSettings';
import PackCards from '../components/pack-cards/PackCards';

import { CREATE_REWARD_CARD_PACK, PUBLISH_REWARD_CARD_PACK, EDIT_REWARD_CARD_PACK } from './services/graphql';
import styles from './RewardCardsPack.module.scss';

const TABS = {
    settings: 1,
    cards: 2,
};

const RewardCardsPack = ({ location }) => {
    const [rewardPack, setRewardPack] = useState(location.state ?? null);
    const [selectedTab, setSelectedTab] = useState(TABS.settings);
    const [savedCardPackId, setSavedCardPackId] = useState('');
    const [packDesignUrl, setPackDesignUrl] = useState('');

    const settingsRef = useRef(null);
    const isNewPack = location.pathname.split('/').pop() === 'new';

    const [saveRewardPack, { loading: saving }] = useMutation(CREATE_REWARD_CARD_PACK, {
        onCompleted: (data) => {
            setSavedCardPackId(data.createRewardCardPack.rewardCardPack.id);
            setRewardPack(data.createRewardCardPack.rewardCardPack)
            alert('Card pack saved edited successfully')

        },
        update: (_, { data }) => {
            if (data.errors) {
                alert(data.errors[0]);
            }
        },
    });

    const handleSave = () => {
        const data = settingsRef.current?.getData();
        saveRewardPack({
            variables: {
                name: data.title,
                coverImageUrl: data.packBackUrl,
                designImageUrl: data.packDesignUrl,
                previewImageUrl: data.packPreviewUrl
            },
        })
    };

    const [editRewardPack, { loading: editing }] = useMutation(EDIT_REWARD_CARD_PACK, {
        onCompleted: (data) => {
            setRewardPack(data.editRewardCardPack.rewardCardPack);
            alert('Card pack was edited successfully');
        },
        update: (_, { data }) => {
            if (data.errors) {
                alert(data.errors[0]);
            }
        },
    })

    const handleEdit = () => {
        const data = settingsRef.current?.getData();
        editRewardPack({
            variables: {
                rewardCardPackId: rewardPack.id,
                name: data.title,
                coverImageUrl: data.packBackUrl,
                designImageUrl: data.packDesignUrl,
                previewImageUrl: data.packPreviewUrl
            },
        })
    }


    const [publishRewardPack, { loading: publishing }] = useMutation(PUBLISH_REWARD_CARD_PACK, {
        onCompleted: (data) => {
            setRewardPack(data.updateRewardCardPackPublishedStatus.rewardCardPack);
             alert('Card pack was published successfully')
        }
    });

    const handlePublish = () => {
        publishRewardPack({
            variables: {
                rewardCardPackId: rewardPack.id,
                published: !rewardPack.published
            }
        })
    };

    if (rewardPack) {
        return <>
            <BackLink to='/rewardPacks' text='Back' />

            <ActionsHeader
                handleSave={handleSave}
                handleEdit={handleEdit}
                handlePublish={handlePublish}
                saving={saving}
                publishing={publishing}
                editing={editing}
                savedCardPackId={savedCardPackId || rewardPack.id}
                isPublished={rewardPack.published}
            />

            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.settings}
                    onClick={() => setSelectedTab(TABS.settings)}
                >
                    Settings
                </Tab>
                <Tab
                    selected={selectedTab === TABS.cards}
                    onClick={() => setSelectedTab(TABS.cards)}
                >
                    Cards
                </Tab>
            </Tabs>

            <div style={{ display: selectedTab === TABS.settings ? 'block' : 'none' }}>
                <PackSettings
                    rewardPack={rewardPack}
                    ref={settingsRef}
                    isNewPack={isNewPack}
                    onPackDesignUrlChange={setPackDesignUrl}
                />
            </div>
            <div style={{ display: selectedTab === TABS.cards ? 'block' : 'none' }}>
                <PackCards
                    isNewPack={isNewPack}
                    rewardPack={rewardPack}
                    packDesignUrl={packDesignUrl}
                    savedCardPackId={savedCardPackId || rewardPack.id}
                />
            </div>
        </>
    }

    return null;
};

function ActionsHeader({ handleSave, handleEdit, handlePublish, savedCardPackId, saving, publishing, editing, isPublished }) {
    return (
        <div className={styles.Header}>
            <div className={styles.TitleIconContainer}>
                <h2 className={styles.HeaderTitle}>Reward Card</h2>
            </div>

            <div>
                <button
                    disabled={!savedCardPackId || saving || editing || publishing}
                    onClick={handlePublish}
                    className={styles.PublishButton}
                >
                    {isPublished ? 'Unpublish': 'Publish'}
                </button>

                <button
                    disabled={saving || editing || publishing}
                    onClick={savedCardPackId ? handleEdit : handleSave}
                    className={styles.SaveDraftButton}
                >
                    {savedCardPackId ? 'Edit' : 'Save Draft'}
                </button>
            </div>
        </div>
    );
}

export default RewardCardsPack;